/** Языки интерфейса (10) + оригинал ru. Совпадает с API translations. */

export const ORIGINAL_LANGUAGE = 'ru';

export const INTERFACE_LANGUAGES = [
  { code: 'ru', label: 'Русский', is_original: true },
  { code: 'uk', label: 'Украинский', is_original: false },
  { code: 'be', label: 'Белорусский', is_original: false },
  { code: 'pl', label: 'Польский', is_original: false },
  { code: 'en', label: 'Английский', is_original: false },
  { code: 'es', label: 'Испанский', is_original: false },
  { code: 'de', label: 'Немецкий', is_original: false },
  { code: 'fr', label: 'Французский', is_original: false },
  { code: 'hi', label: 'Хинди', is_original: false },
  { code: 'tr', label: 'Турецкий', is_original: false },
];

export const TRANSLATION_LANGUAGE_CODES = INTERFACE_LANGUAGES
  .filter((lang) => !lang.is_original)
  .map((lang) => lang.code);

export const INTERFACE_LANGUAGE_CODES = INTERFACE_LANGUAGES.map((lang) => lang.code);

export function getInterfaceLanguageLabel(code) {
  const found = INTERFACE_LANGUAGES.find((lang) => lang.code === code);
  return found?.label || code || '—';
}

export function formatLanguageDisplayName(language) {
  if (!language) return '—';
  const parts = [language.name];
  if (language.native_name && language.native_name !== language.name) {
    parts.push(language.native_name);
  }
  if (language.code) {
    parts.push(`(${language.code})`);
  }
  return parts.filter(Boolean).join(' · ');
}

/**
 * Среди выбранных языков карточки должен быть ≥1 язык интерфейса.
 * Если is_for_all_languages — список языков не обязателен.
 */
export function validateCardLanguages({ languages = [], isForAllLanguages = false } = {}) {
  if (isForAllLanguages) {
    return null;
  }
  if (!languages?.length) {
    return 'укажите хотя бы один язык или включите «для всех языков»';
  }
  const hasInterface = languages.some(
    (lang) => lang?.is_interface_language
      || INTERFACE_LANGUAGE_CODES.includes(lang?.code),
  );
  if (!hasInterface) {
    return 'среди выбранных языков должен быть хотя бы один язык интерфейса';
  }
  return null;
}
